import PropTypes from 'prop-types';
import { RendererProvider, ThemeProvider } from 'react-fela';
import { createRenderer } from 'fela';

import { childrenPropType } from 'config/childrenPropType';

import config from '../config';

const renderer = createRenderer(config);

const Fela = ({ theme, children }) => (
    <RendererProvider renderer={renderer}>
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </RendererProvider>
);

Fela.propTypes = {
    theme: PropTypes.shape(),
    children: childrenPropType.isRequired,
};

Fela.defaultProps = {
    theme: {},
};

export default Fela;
